import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Table, TableBody, TableRow, TableHead, TableCell, Alert, Body1 } from '@dhl-ui/components'
import { useGetDtsFlows, type DtsRelationDto, type DtsFlowSummaryDto } from '@dhl/mdp-api'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'
import { PppRelationFlow } from '~/modules/ppp/submodules/relations/components'

type Props = {
  relation: DtsRelationDto
}
export const PppRelation = ({ relation }: Props) => {
  const [selectedFlow, setSelectedFlow] = useState<DtsFlowSummaryDto | undefined>(undefined)
  const { data: flows, isSuccess } = useGetDtsFlows({ relationId: relation.id, sort: 'name' })
  const { t } = useTranslation()

  useEffect(() => {
    const clearSelectedFlow = () => {
      setSelectedFlow(undefined)
    }
    clearSelectedFlow()
  }, [relation])

  return (
    isSuccess && (
      <>
        <Box sx={{ mt: 2 }}>
          <Table data-testid="ppp-relation-flows-table">
            <TableHead>
              <TableRow>
                <TableCell>{t('admin.pppRelationsPage.flowsTable.name')}</TableCell>
                <TableCell>{t('admin.pppRelationsPage.flowsTable.converterImplementation')}</TableCell>
                <TableCell>{t('admin.pppRelationsPage.flowsTable.enabled')}</TableCell>
                <TableCell>{t('admin.pppRelationsPage.flowsTable.activationDate')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {flows.map((flow) => (
                <TableRow
                  key={flow.flowName}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                  onClick={() => setSelectedFlow(flow)}
                >
                  <TableCell>
                    <Body1>{flow.flowName}</Body1>
                  </TableCell>
                  <TableCell>
                    <Body1>{flow.converterImplementation}</Body1>
                  </TableCell>
                  <TableCell>
                    <Body1>
                      {flow.enabled ? t('admin.pppRelationsPage.enabled') : t('admin.pppRelationsPage.disabled')}
                    </Body1>
                  </TableCell>
                  <TableCell>
                    <Body1>{presentDateOrDefault(flow.activationDate)}</Body1>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        {selectedFlow ? (
          <PppRelationFlow flow={selectedFlow} />
        ) : (
          <Alert severity="info" sx={{ mt: 2 }}>
            {flows.length === 0 ? t('admin.pppRelationsPage.noFlows') : t('admin.pppRelationsPage.selectFlow')}
          </Alert>
        )}
      </>
    )
  )
}
